import { type ReactNode } from 'react';
import cn from 'classnames';
import s from './PageTitle.module.scss';

interface IPageTitleProps {
  children?: ReactNode;
  auth?: boolean;
  className?: string;
}

const PageTitle = ({ children, auth, className }: IPageTitleProps) => (
  <h1 className={cn(auth ? s.authPageTitle : s.appPageTitle, className)}>{children}</h1>
);

export default PageTitle;
